<script setup lang="ts">
import { onMounted } from "vue";
import { useFreeTierStatus } from "@/composables/useFreeTierStatus";
import { openStripePortal } from "@/services/billing";

const { limitReached, ensureCounts, FREE_TIER_LIMIT } = useFreeTierStatus();

onMounted(() => {
  ensureCounts();
});
</script>

<template>
  <v-system-bar v-if="limitReached" app height="44" class="upgrade-banner" color="#1565C0">
    <div class="upgrade-banner-inner">
      <v-icon size="16" class="mr-2">mdi-lock-outline</v-icon>
      <span class="upgrade-text">
        Du har nået din gratis grænse på {{ FREE_TIER_LIMIT }} fakturaer og køb.
      </span>
      <button class="upgrade-btn" @click="openStripePortal()">Opgrader for kun 29 kr.</button>
    </div>
  </v-system-bar>
</template>

<style scoped>
.upgrade-banner {
  color: #fff !important;
}
.upgrade-banner-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 0 12px;
  font-size: 0.82rem;
  font-weight: 500;
  overflow: hidden;
}
.upgrade-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.upgrade-btn {
  background: #fff;
  color: #1565c0;
  border: none;
  border-radius: 999px;
  padding: 3px 14px;
  font-size: 0.78rem;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.15s ease;
}
.upgrade-btn:hover {
  opacity: 0.88;
}
</style>
